<template>
  <div class="add">
    <div class="emptyAdd" v-if="!show">
      <a-button @click="addPersonalFence" class="addbtn" type="primary" shape="circle" icon="plus"></a-button>
      <div class="text">{{$t('supervise.noPersonalFence')}}</div>
    </div>
    <div v-if="show" class="content-fence">
      <a-form style="width: 100%">
        <a-form-item class="title" :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('supervise.fenceName')">
          <a-input :placeholder="$t('supervise.fenceName')" v-model="fenceName" />
        </a-form-item>

        <a-form-item class="title" :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('supervise.forbidType')">
          <a-radio-group defaultValue="1" v-model="value">
            <a-radio :value="1">{{$t('global.forbidIn')}}</a-radio>
            <a-radio :value="2">{{$t('global.forbidOut')}}</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item class="title" :label="$t('supervise.timeOption')" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
            <a-time-picker
              style="width: 100%"
              format="HH:mm"
              @change="startChange"
              :placeholder="$t('supervise.selecteTimeTip')"
            />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">
            -
          </span>
          <a-form-item class="title" :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
            <a-time-picker
              style="width: 100%"
              format="HH:mm"
              @change="endChange"
              :placeholder="$t('supervise.selecteTimeTip')"
            />
          </a-form-item>
        </a-form-item>

        <a-form-item class="title" :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('supervise.drawFence')">
          <a-select style="width: 270px" @change="selectedDrawMode">
            <a-select-option key="1">{{$t('supervise.drawByWheel')}}</a-select-option>
            <a-select-option key="2">{{$t('supervise.district')}}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item class="title" v-if="showProvince" :label-col="labelCol" :wrapper-col="wrapperCol">
          <ProvinceSelec @provinceData="getSelectedProvinceData" :map="this.map" />
        </a-form-item>

        <a-form-item class="title" :label-col="labelCol" :wrapper-col="wrapperCol" :label="$t('supervise.personalFence')">
          <!-- <a-input-number style="width: 100%" /> -->
          <FenceMap @getMap="getMap" idName="add" />
          <AutoComplete v-model="circle" v-if="showAutoComplete" @circleChange="circleChange" :map="map" />
        </a-form-item>

        <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-button class="btn" :disabled="!canSubmit" type="primary" @click="addFence">{{$t('supervise.addPersonalFence')}}</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
  import FenceMap from '../../components/common/BMap'
  import ProvinceSelec from '../../components/common/ProvinceSelec'
  import AutoComplete from '../../components/BMapComponents/AutoComplete'
  import MapDrawer from '../../utils/MapDrawer'
  import config from '../../config/'
  import moment from 'moment'
  export default {
    components: {
      FenceMap,
      ProvinceSelec,
      AutoComplete
    },
    props: {
      personId: {
        required: true,
        type: Number
      },
      personInfo: {
        default: {}
      }
    },
    data() {
      return {
        startTime: '',
        endTime: '',
        showProvince: false,
        show: false,
        // 围栏名称
        fenceName: '',
        // 约束类型
        value: '',
        current: 0,
        labelCol: {
          span: 2
        },
        wrapperCol: {
          span: 21
        },
        // 百度地图实例
        map: '',
        // 个人围栏绘制方式
        drawMode: '',
        // 围栏绘制的数据
        drawData: {},
        overlays: [],
        Drawer: undefined,
        showAutoComplete: false,
        circle: {}
      }
    },
    computed: {
      canSubmit () {
        if (this.fenceName && this.value && this.drawData.parameter) {
          return true
        } else {
          return false
        }
      },
    },
    methods: {
      getSelectedProvinceData (SelectedProvinceData) {
        this.drawData = SelectedProvinceData
        // console.log(SelectedProvinceData)
      },
      addFence () {
        // 1 获取创建的围栏数据
        let fenceData = {
          applyAll: true,
          coordType: 'BD09',
          opt: this.value,
          type: this.drawData.type,
          name: this.fenceName,
          value: this.value,
          parameter: this.drawData.parameter,
          acl: (this.startTime && this.endTime) ? [`${this.startTime}~${this.endTime}~1`] : []
        }
        // console.log(fenceData)
        // 验证数据的完整性

        // 2 提交数据
        this.$http.post(config.api.add_personnal_fence + this.personId, [fenceData]).then((res) => {
          // console.log(res)
          if (res.code === 0) {
            this.$notification.open({
              message: this.$t('global.commitSuccess'),
              icon: <a-icon type="smile" style="color: #108ee9" />,
            })
            this.$emit('addOk')
          } else {
            this.$notification.open({
              message: res.desc
            })
          }
        })
      },
      // 增加个人围栏
      addPersonalFence() {
        this.show = true
      },
      getMap(e) {
        this.map = e
      },
      circleChange (data) {
        // console.log(data)
        if (this.overlays[0]) {
          // console.log(this.overlays[0])
          // console.log(this.circle)
          this.overlays[0].setCenter(this.circle.center)
          this.overlays[0].setRadius(this.circle.radius)
          // 圆
          this.drawData = {
            type: 'circle',
            parameter: {
              points: [
                [
                  {
                    lat: this.circle.center.lat,
                    lng: this.circle.center.lng
                  }
                ]
              ],
              radius: this.circle.radius
            }
          }
          // this.$emit('mapDataChange', drawData)
        }
      },
      selectedDrawMode(e) {
        // console.log(e)
        this.overlays = []
        this.map.clearOverlays()
        if (e === '1') {
          this.showProvince = false
          // 在手动绘制围栏的时候，会生成画图的控件，先捕获到这个控件，方便以后移除
          this.map.addEventListener('addcontrol', (ev) => {
            // console.log(ev)
            this.control = ev.target
          })
          // 手动绘制
          this.Drawer = new MapDrawer(this.map, this.overlays)
          let drawManger = this.Drawer.getDrawingManager()
          this.drawManger = drawManger
          // console.log(drawManger)
          this.map && this.map.addEventListener('click', (ev) => {
            // console.log(ev)
            let drawType = drawManger.getDrawingMode()
            // console.log(drawType)
            // 用户开始画圆或者点了圆心
            if (drawType === 'circle') {
              // console.log(true)
              this.showAutoComplete = true
              // 只点了一个点
              // 1、解析出中心点，显示出来，是否联想周边地区
              // 2、 此时用户可以选择-自定义设置圆形围栏的半径-m
              // 3、 设置之后画出圆形围栏
              // 4、 是否修改
            } else {
              // 取消选择框之类的组件
              this.showAutoComplete = false
            }
          })
          // 默认选择画圆
          // 当存在实体住址的时候
          // console.log(this.personInfo)
          if (this.personInfo.住址 || this.personInfo.address) {
            drawManger.setDrawingMode(window.BMAP_DRAWING_CIRCLE)
            this.showAutoComplete = true
            // 默认画上一个圆
            // 解析地址为百度坐标点
            let address = this.personInfo.住址 || this.personInfo.address
            // 创建地址解析器实例
            let myGeo = new window.BMap.Geocoder()
            // 将地址解析结果显示在地图上,并调整地图视野
            myGeo.getPoint(address, (point) => {
              // console.log(point)
              if (point) {
                this.map.centerAndZoom(point, 13)
                // 画一个圆形覆盖物
                let circleOverlay = new window.BMap.Circle(point, 5000, {
                  //边线颜色。
                  strokeColor:"red",
                  //填充颜色。当参数为空时，圆形将没有填充效果   
                  fillColor:"red",
                  //边线的宽度，以像素为单位    
                  strokeWeight: 3,
                  //边线透明度，取值范围0 - 1     
                  strokeOpacity: 0.8,
                  //填充的透明度，取值范围0 - 1	   
                  fillOpacity: 0.6,
                  //边线的样式，solid或dashed    
                  strokeStyle: 'solid'
                })
                // map上只能有一个overlay
                if (this.overlays.length === 0) {
                  this.overlays.push(circleOverlay)
                } else {
                  this.map.removeOverlay(this.overlays[0])
                  this.overlays = []
                  this.overlays.push(circleOverlay)
                }
                this.map.addOverlay(circleOverlay)
                
                this.circle.address = address
                this.circle.center = point
                this.circle.radius = 5000
                this.circle = {...this.circle}
                // console.log(this.circle)
                this.drawData = {
                  type: 'circle',
                  parameter: {
                    points: [
                      [
                        {
                          lat: this.circle.center.lat,
                          lng: this.circle.center.lng
                        }
                      ]
                    ],
                    radius: this.circle.radius
                  }
                }
                drawManger.close()
                
              } else {
                this.$message.error(`无法解析当前地址--${address}`)
              }
            })
            
          }
          
          drawManger.addEventListener('circlecomplete', (ev) => {
            // console.log('complete')
            // console.log(ev)
            this.showAutoComplete = true
            let geoc = new window.BMap.Geocoder()
            let point = ev.getCenter()
            geoc.getLocation(point, (res) => {
              let address
              // console.log(res)
              if (res.address !== '') {
                address = res.address
              } else if ((res.addressComponents.city !== '') && (res.addressComponents.country !== '')) {
                address = res.addressComponents.city + ', ' + res.addressComponents.country
              }
              this.circle.address = address
              this.circle.center = ev.getCenter()
              this.circle.radius = Math.floor(ev.getRadius())
              // console.log(this.circle)
              // this.$nextTick().then(() => {
                this.circle = {...this.circle}
              // })
            })
            drawManger.close()
          })
          drawManger.addEventListener('overlaycomplete', (ev) => {
            console.log(ev)
            // 获取画的图形数据
            // map上只能有一个overlay
            if (this.overlays.length === 0) {
              this.overlays.push(ev.overlay)
            } else {
              this.map.removeOverlay(this.overlays[0])
              this.overlays = []
              this.overlays.push(ev.overlay)
            }
            // let drawData
            if (ev && ev.drawingMode === 'circle') {
              // 圆
              this.drawData = {
                type: ev.drawingMode,
                parameter: {
                  points: [
                    [{
                      lat: ev.overlay.point.lat,
                      lng: ev.overlay.point.lng
                    }]
                  ],
                  radius: ev.overlay.getRadius()
                },
              }
            } else {
              this.showAutoComplete = false
              // 其他图形
              // console.log(ev.overlay.getPath())
              let points = ev.overlay.getPath()
              this.drawData = {
                type: ev.drawingMode,
                parameter: {
                  points: [
                    // ev.overlay.ia
                    [...points, points[0]]
                  ]
                }
              }
            }
            // console.log(this.drawData)
            drawManger.close()
            // 发送事件通知数据改变了,需要一个围栏id，才能使得父级组件知道改变的是哪一个围栏
            // this.$emit('mapDataChange', {id: this.mapData.id, drawData})
          })
          // console.log(Drawer)
        } else {
          // 选择行政区
          // console.log(this.map)
          // 移除鼠标绘制的控件
          this.control && this.map.removeControl(this.control)
          // 清除覆盖物即是现有的围栏
          this.map.clearOverlays()
          this.showAutoComplete = false
          this.drawManger && this.drawManger.close()
          // 显示选择行政区
          this.showProvince = true
        }
      },
      startChange (time) {
      // console.log(moment(time).unix())
      this.startTime = moment(time).unix()
      },
      endChange (time) {
        // console.log(moment(time).unix())
        this.endTime = moment(time).unix()
      }
    }
  }
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.ant-col-2 {
  width: auto !important;
}
  .add {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 60vh;
    .emptyAdd {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      min-height: 60vh;
      .addbtn {
        font-size: 50px;
        line-height: 100px;
        height: 100px;
        width: 100px;
      }
      .text {
        color: @text-color-secondary;
        margin-top: 20px;
        font-size: 18px;
      }
    }
    .title {
      color: @text-color;
    }
    .content-fence {
      width: 100%;

      .ant-form-item {
        margin-bottom: 0;
      }
    }

    .steps {
      width: 100%;
    }
    .btn {
      width: 30%;
      margin: 20px 0 0 80px;
    }
  }
</style>